interface LocalEmployersProps {
  career: any;
}
const LocalEmployers: React.FC<LocalEmployersProps> = ({ career }) => {
  return (
    <>
      {Boolean(career.localEmployers && career.localEmployers.length) && (
        <div className="my-10 md:my-18">
          <h2 className="text-2xl font-semibold md:text-4xl leading-heading2 text-careerPageHeading">
            Local Employers
          </h2>
          <div className="p-4 my-6 bg-white md:my-10 rounded-2xl">
            {career.localEmployers.map((employer: any) => {
              return (
                <>
                  <div className="flex flex-col w-full p-6 md:flex-row md:items-center md:jusfity-between">
                    <div>
                      <p className="font-medium text-gnoIncMdBlue font-base md:text-lg">
                        {employer.employerName}
                      </p>
                      <p className="text-xl font-semibold underline text-careerPageHeading md:text-2xl">
                        {employer.positionName}
                      </p>
                    </div>
                    <p className="text-sm md:ml-auto text-gray4 md:text-base">
                      {employer.location}
                    </p>
                  </div>
                  <div className="px-6">
                    <div className="w-full border-b-2 border-dashed border-borderGray"></div>
                  </div>
                </>
              );
            })}
          </div>
        </div>
      )}
    </>
  );
};

export default LocalEmployers;
